"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function ProductsHero() {
  // 保留滾動偵測機制
  const {
    ref: headerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={headerRef} data-section-id="189635" id="productshero" className="relative h-[55vh] min-h-[450px] md:min-h-[550px] w-full overflow-hidden bg-[#f3ede5] flex items-center">
    
      <div className="absolute inset-0 z-0">
        <img src="https://hent.services/wp-content/uploads/2026/05/Flooring_TOP.webp" alt="Hent's Flooring Premium Collection" className="h-full w-full object-cover object-center scale-100" />
        <div className="absolute inset-0 bg-white/5 md:bg-transparent" />
      </div>

      {/* 內容排版層 - 完美還原圖片幾何配置 */}
      <div className="container relative z-30 mx-auto px-6 md:px-12 lg:px-24">
        <div className={cn("max-w-3xl transition-all duration-[1200ms] ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0")}>
          
       
          <nav className="mb-8 md:mb-12 flex items-center gap-1.5 text-lg md:text-xl font-sans tracking-[0.25em] text-[#7a6a59] font-medium">
            <Link to="/" className="hover:text-[#604f45] transition-colors">HOME</Link>
            <span>/</span>
            <span className="text-[#604f45] uppercase">Flooring</span>
          </nav>

          <div className="flex items-stretch gap-x-5 md:gap-x-6 select-none">
            
          
            <div className="w-[5px] bg-[#604f45] my-1 shrink-0 opacity-90" />
            
           
            <div className="flex flex-col justify-center space-y-1.5 md:space-y-2">
              <h1 className="font-hk-regular text-1xl md:text-3xl font-medium text-[#3d3d3d] tracking-widest leading-snug">
                挑選屬於你的理想地板
              </h1>
              <p className="font-hk-regular text-1xl md:text-3xl font-medium text-[#3d3d3d]/90 tracking-widest leading-snug">
                讓每一步成為生活中最舒服的風景
              </p>
            </div>

          </div>

        </div>
      </div>
    </section>;
}